import { SitePackageDefinitionV1Schema, } from "../contracts/site-package.js";
const ONE_PAGE_ROUTES = [
    { routeId: "home", path: "/", pageTitle: "Home" },
];
const BASIC_3_ROUTES = [
    { routeId: "home", path: "/", pageTitle: "Home" },
    { routeId: "services", path: "/services", pageTitle: "Services" },
    { routeId: "contact", path: "/contact", pageTitle: "Contact" },
];
const STANDARD_5_ROUTES = [
    { routeId: "home", path: "/", pageTitle: "Home" },
    { routeId: "about", path: "/about", pageTitle: "About" },
    { routeId: "services", path: "/services", pageTitle: "Services" },
    { routeId: "service-areas", path: "/service-areas", pageTitle: "Service Areas" },
    { routeId: "contact", path: "/contact", pageTitle: "Contact" },
];
const GROWTH_8_ROUTES = [
    { routeId: "home", path: "/", pageTitle: "Home" },
    { routeId: "about", path: "/about", pageTitle: "About" },
    { routeId: "services-overview", path: "/services", pageTitle: "Services Overview" },
    { routeId: "service-detail-1", path: "/service-detail-1", pageTitle: "Service Detail 1" },
    { routeId: "service-detail-2", path: "/service-detail-2", pageTitle: "Service Detail 2" },
    { routeId: "service-detail-3", path: "/service-detail-3", pageTitle: "Service Detail 3" },
    { routeId: "service-areas", path: "/service-areas", pageTitle: "Service Areas" },
    { routeId: "contact", path: "/contact", pageTitle: "Contact" },
];
const AUTHORITY_10_ROUTES = [
    { routeId: "home", path: "/", pageTitle: "Home" },
    { routeId: "about", path: "/about", pageTitle: "About" },
    { routeId: "services-overview", path: "/services", pageTitle: "Services Overview" },
    { routeId: "service-detail-1", path: "/service-detail-1", pageTitle: "Service Detail 1" },
    { routeId: "service-detail-2", path: "/service-detail-2", pageTitle: "Service Detail 2" },
    { routeId: "service-detail-3", path: "/service-detail-3", pageTitle: "Service Detail 3" },
    { routeId: "service-detail-4", path: "/service-detail-4", pageTitle: "Service Detail 4" },
    { routeId: "service-areas", path: "/service-areas", pageTitle: "Service Areas" },
    { routeId: "gallery", path: "/gallery", pageTitle: "Gallery" },
    { routeId: "contact", path: "/contact", pageTitle: "Contact" },
];
const AUTHORITY_15_ROUTES = [
    { routeId: "home", path: "/", pageTitle: "Home" },
    { routeId: "about", path: "/about", pageTitle: "About" },
    { routeId: "services-overview", path: "/services", pageTitle: "Services Overview" },
    { routeId: "service-detail-1", path: "/service-detail-1", pageTitle: "Service Detail 1" },
    { routeId: "service-detail-2", path: "/service-detail-2", pageTitle: "Service Detail 2" },
    { routeId: "service-detail-3", path: "/service-detail-3", pageTitle: "Service Detail 3" },
    { routeId: "service-detail-4", path: "/service-detail-4", pageTitle: "Service Detail 4" },
    { routeId: "service-detail-5", path: "/service-detail-5", pageTitle: "Service Detail 5" },
    { routeId: "service-detail-6", path: "/service-detail-6", pageTitle: "Service Detail 6" },
    { routeId: "service-areas", path: "/service-areas", pageTitle: "Service Areas Overview" },
    { routeId: "location-1", path: "/location-1", pageTitle: "Location 1" },
    { routeId: "location-2", path: "/location-2", pageTitle: "Location 2" },
    { routeId: "location-3", path: "/location-3", pageTitle: "Location 3" },
    { routeId: "gallery", path: "/gallery", pageTitle: "Gallery" },
    { routeId: "contact", path: "/contact", pageTitle: "Contact" },
];
export const SITE_PACKAGE_REGISTRY = {
    "package-one-page": SitePackageDefinitionV1Schema.parse({
        schemaVersion: "site-package-definition.v1.0",
        sitePackageId: "package-one-page",
        displayName: "One Page",
        routes: ONE_PAGE_ROUTES,
        recipeReferences: [{ recipeId: "flat-2-one-page", sectionRoles: ["hero", "services", "contact"] }],
        tier1Allowed: true,
        tier2Allowed: false,
        roadmapBlocked: false,
    }),
    "package-basic-3": SitePackageDefinitionV1Schema.parse({
        schemaVersion: "site-package-definition.v1.0",
        sitePackageId: "package-basic-3",
        displayName: "Basic Three Page",
        routes: BASIC_3_ROUTES,
        recipeReferences: [{ recipeId: "flat-2-basic-3", sectionRoles: ["hero", "services", "contact"] }],
        tier1Allowed: true,
        tier2Allowed: false,
        roadmapBlocked: false,
    }),
    "package-standard-5": SitePackageDefinitionV1Schema.parse({
        schemaVersion: "site-package-definition.v1.0",
        sitePackageId: "package-standard-5",
        displayName: "Standard Five Page",
        routes: STANDARD_5_ROUTES,
        recipeReferences: [
            { recipeId: "flat-2-standard-5", sectionRoles: ["hero", "about", "services", "service-areas", "contact"] },
        ],
        tier1Allowed: true,
        tier2Allowed: false,
        roadmapBlocked: false,
    }),
    "package-growth-8": SitePackageDefinitionV1Schema.parse({
        schemaVersion: "site-package-definition.v1.0",
        sitePackageId: "package-growth-8",
        displayName: "Growth Eight Page",
        routes: GROWTH_8_ROUTES,
        recipeReferences: [{ recipeId: "flat-2-growth-8", sectionRoles: ["hero", "about", "services", "service-areas", "contact"] }],
        tier1Allowed: false,
        tier2Allowed: true,
        roadmapBlocked: false,
    }),
    "package-authority-10": SitePackageDefinitionV1Schema.parse({
        schemaVersion: "site-package-definition.v1.0",
        sitePackageId: "package-authority-10",
        displayName: "Authority Ten Page",
        routes: AUTHORITY_10_ROUTES,
        recipeReferences: [{ recipeId: "flat-2-authority-10", sectionRoles: ["hero", "about", "services", "gallery", "contact"] }],
        tier1Allowed: false,
        tier2Allowed: true,
        roadmapBlocked: false,
    }),
    "package-authority-15": SitePackageDefinitionV1Schema.parse({
        schemaVersion: "site-package-definition.v1.0",
        sitePackageId: "package-authority-15",
        displayName: "Authority Fifteen Page",
        routes: AUTHORITY_15_ROUTES,
        recipeReferences: [{ recipeId: "flat-2-authority-15", sectionRoles: ["hero", "about", "services", "gallery", "contact"] }],
        tier1Allowed: false,
        tier2Allowed: true,
        roadmapBlocked: false,
    }),
};
export function getSitePackageDefinition(sitePackageId) {
    return SITE_PACKAGE_REGISTRY[sitePackageId];
}
export function resolveSitePackagePlan(sitePackageId, policyVersion = "site-package-registry.v1.0") {
    const def = getSitePackageDefinition(sitePackageId);
    return {
        schemaVersion: "resolved-site-package-plan.v1.0",
        sitePackageId: def.sitePackageId,
        routes: def.routes,
        recipeReferences: def.recipeReferences,
        resolvedAt: new Date().toISOString(),
        policyVersion,
    };
}
/** Bridge PackPin recipeId to sitePackageId for one-page compatibility. */
export function sitePackageIdFromRecipeId(recipeId) {
    if (recipeId.includes("authority-15"))
        return "package-authority-15";
    if (recipeId.includes("authority-10"))
        return "package-authority-10";
    if (recipeId.includes("growth-8"))
        return "package-growth-8";
    if (recipeId.includes("standard-5"))
        return "package-standard-5";
    if (recipeId.includes("basic-3"))
        return "package-basic-3";
    return "package-one-page";
}
export function recipeIdFromSitePackageId(sitePackageId) {
    return getSitePackageDefinition(sitePackageId).recipeReferences[0]?.recipeId ?? "flat-2-one-page";
}
//# sourceMappingURL=site-package-registry.js.map